var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('v-card',{attrs:{"outlined":""}},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"allowfullscreen":""}})]):_c('v-card',{attrs:{"outlined":""}},[_c('no-content-screen',{attrs:{"title":_vm.$t('performance.no-content-screen.title'),"sub-title":_vm.$t('performance.no-content-screen.subtitle')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }